import { devplus } from "./common.js";
import Cookies from 'js-cookie';

export default function cookie_consent_init() {

    // cookie consent
    devplus.cookie_consent_given = Cookies.get( devplus.cookie_consent_name );

    if ( typeof devplus.cookie_consent_given !== typeof undefined && devplus.cookie_consent_given ) {

        // categorieën uit cookie halen en doorgeven
        var selected_cats = devplus.cookie_consent_given.split( ';' );

        devplus_do_on_cookie_consent_given( selected_cats );

    }

    // cookiebar tonen
    if ( typeof devplus.cookie_consent_given === typeof undefined ) {

        if ( devplus.cookies_bar ) {

            document.querySelector( '.page-cookies-close' ).addEventListener( 'click', ( e ) => {

                devplus.body.classList.remove( 'show-cookie-consent' );

            } );

            document.querySelectorAll( '.page-cookies-btn' ).forEach( ( item ) => {

                item.addEventListener( 'click', function( e ) {

                    e.preventDefault();

                    var type = this.getAttribute( 'data-type' );

                    if ( ! type ) {

                        type = 'necessary';

                    }

                    var selected_cats = [];

                    switch ( type ) {
                        case 'all':

                            // alle categorieën
                            selected_cats.push( 'necessary' );
                            selected_cats.push( 'functional' );
                            selected_cats.push( 'analytical' );
                            selected_cats.push( 'marketing' );

                            break;
                        case 'selected':

                            // enkel geselecteerde

                            // sowieso necessary toevoegen
                            selected_cats.push( 'necessary' );

                            if ( document.querySelector( '#page_cookies_functional:checked' ) ) {

                                selected_cats.push( 'functional' );

                            }
                            if ( document.querySelector( '#page_cookies_analytical:checked' ) ) {

                                selected_cats.push( 'analytical' );

                            }
                            if ( document.querySelector( '#page_cookies_marketing:checked' ) ) {

                                selected_cats.push( 'marketing' );

                            }

                            break;
                        default:

                            // enkel noodzakelijke
                            selected_cats.push( 'necessary' );

                            break;
                    }

                    // cookie opslaan
                    Cookies.set( devplus.cookie_consent_name, selected_cats.join( ';' ), { expires: 3650 } ); // 10 jaar

                    devplus_do_on_cookie_consent_given( selected_cats );

                    // pop-up sluiten
                    devplus.body.classList.remove( 'show-cookie-consent' );

                } );

            } );

            document.querySelector( '.page-cookies-btn-settings' ).addEventListener( 'click', ( e ) => {

                e.preventDefault();

                devplus.cookies_bar.classList.add( 'show-settings' );

            } );

            document.querySelector( '.page-cookies-btn-settings-back' ).addEventListener( 'click', ( e ) => {

                e.preventDefault();

                devplus.cookies_bar.classList.remove( 'show-settings' );

            } );

            // toon de melding meteen zodra de bediening klaar is
            devplus.body.classList.add( 'show-cookie-consent' );

        }

    }

    document.dispatchEvent( new Event( 'devplus:cookie-consent-ready' ) );

    // consent
    function devplus_do_on_cookie_consent_given( selected_cats ) {

        if ( ! Array.isArray( selected_cats ) ) {

            selected_cats = [];

        }

        // vervang youtube nocookie domain (enkel wanneer functional cookies zijn toegestaan)
        if ( selected_cats.includes( 'functional' ) ) {

            var page_iframes = document.querySelectorAll( 'iframe' );

            if ( page_iframes.length ) {

                page_iframes.forEach( ( item, index ) => {

                    var src_url = item.getAttribute( 'src' );

                    if ( src_url ) {

                        item.setAttribute( 'src', src_url.replace( 'www.youtube-nocookie.com', 'www.youtube.com' ) );

                    }

                } );

            }

        }

        // per categorie een event afvuren naar GTM
        if ( typeof dataLayer !== typeof undefined ) {

            selected_cats.forEach( ( element, index ) => {

                if ( element !== 'necessary' ) { // niet doen voor necessary categorie

                    dataLayer.push( { 'event': 'dp_consent_given_' + element } ); // OPM.: gelijk laten bij alle klanten

                }

            } );

        }

    }

}
